import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { FaFileExcel, FaPlusCircle, FaTrash } from "react-icons/fa";
import { useOutletContext } from "react-router-dom";
import { rootUrl } from "../../../helpers";
import { useAuth } from "../../../context/auth-context";
import { CiShoppingCart } from "react-icons/ci";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

export default function Sale() {

  const [barcodes, setBarcodes] = useState([]);
  const [sales, setSales] = useState([{ id: Date.now(), rec: "", barcode: null, qty: "", sale: "" }]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
   const [excelData, setExcelData] = useState([]);

  const {allData, setAllData} = useOutletContext();
  const auth = useAuth()
 
  // Fetch Barcodes from API
  useEffect(() => {
    async function fetchBarcodes() {
      try {
       const barcodeOptions = allData.products.map((product) => ({
          value: product.barcode,
          label: `${product.name}`,
        }));
        setBarcodes(barcodeOptions);
      } catch (error) {
        console.error("Error fetching barcodes:", error);
      }
    }
    fetchBarcodes();
  }, []);

  // Handle Input Change
  const handleChange = (index, name, value) => {
    const updatedSales = [...sales];
    updatedSales[index][name] = value;
    setSales(updatedSales);
  };

  // Add New Row
  const addSaleRow = () => {
    setSales([...sales, { id: Date.now(), rec: "", barcode: null, qty: "", sale: "" }]);
  };

  // Remove Row
  const removeSaleRow = (id) => {
    setSales(sales.filter((sale) => sale.id !== id));
  };

     const handleFileUpload = (e) => {
          const file = e.target.files[0];
          if (!file) return;
      
          const reader = new FileReader();
          reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const sheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
            setExcelData(sheet);
          };
          reader.readAsArrayBuffer(file);
        };
  
  
        const handleBulkSubmit = async () => {
          setLoading(true);
          try {
            const response = await axios.post(rootUrl(`/sale`), { sales: excelData, shop:auth.user.shop });
            
            if(response.data.status == 200){
              toast.success("Sale successful!");
              setIsModalOpen(false);
              setLoading(false);
            }else{
              toast.error("Error, please again later");
              setLoading(false);
            }
  
          } catch (error) {
            console.error("Upload Error:", error);
            toast.error(error?.message);
            setLoading(false);
          }
        };

  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(rootUrl(`/sale`), { sales, shop:auth.user.shop });
      toast.success("Successful")
      setSales([{ id: Date.now(), rec: "", barcode: null, qty: "", sale: "" }]);
    } catch (error) {
      console.error("Sale Error:", error);
      alert("Failed to record sales.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>

<div className="flex justify-between">

<div className="flex items-center font-bold text-2xl">
        <CiShoppingCart/> Sales
      </div>
      <button
              className="bg-blue-950 text-white px-4 py-2 rounded mb-4 flex items-center"
              onClick={() => setIsModalOpen(true)}
            >
             <FaFileExcel/> Bulk
            </button>

</div>
      
      

      <hr className="my-3"/>


      <form onSubmit={handleSubmit} className="space-y-4">
        {sales.map((sale, index) => (
          <div key={sale.id} className="flex space-x-2 items-center bg-gray-100 p-4 rounded-md">
            {/* Rec Input */}
            <input
              type="text"
              name="rec"
              value={sale.rec}
              onChange={(e) => handleChange(index, e.target.name, e.target.value)}
              placeholder="Rec"
              className="border p-2 w-1/5 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />

            {/* Searchable Barcode Dropdown */}
            <Select
              options={barcodes}
              value={sale.barcode}
              onChange={(selectedOption) => handleChange(index, "barcode", selectedOption)}
              placeholder="Select Barcode"
              className="w-2/5"
              isSearchable
              required
            />

            {/* Quantity Input */}
            <input
              type="number"
              name="qty"
              value={sale.qty}
              onChange={(e) => handleChange(index, e.target.name, e.target.value)}
              placeholder="Qty"
              className="border p-2 w-1/5 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />

            {/* Sale Input */}
            <input
              type="number"
              name="sale"
              value={sale.sale}
              onChange={(e) => handleChange(index, e.target.name, e.target.value)}
              placeholder="Sale"
              className="border p-2 w-1/5 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />

            {/* Remove Row Button */}
            {sales.length > 1 && (
              <button type="button" onClick={() => removeSaleRow(sale.id)} className="text-red-500 hover:text-red-700">
                <FaTrash size={20} />
              </button>
            )}
          </div>
        ))}

        {/* Add Row Button */}
        <button
          type="button"
          onClick={addSaleRow}
          className="flex items-center space-x-2 bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
        >
          <FaPlusCircle size={20} />
          <span>Add Sale</span>
        </button>

        {/* Submit Button */}
        <button
          type="submit"
          className={`w-full px-4 py-2 rounded text-white ${loading ? "bg-gray-500 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"}`}
          disabled={loading}
        >
          {loading ? "Processing..." : "Submit Sales"}
        </button>
      </form>

           {/* Modal */}
           {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="bg-white p-5 rounded shadow-lg w-1/2">
            <h2 className="text-xl font-bold mb-4">Upload</h2>

            {/* File Input */}
            <input
              type="file"
              accept=".xlsx, .xls"
              className="mb-3 p-2 border w-full"
              onChange={handleFileUpload}
            />

               {/* Buttons */}
               <div className="flex justify-end my-4">
              <button
                className="bg-gray-500 text-white px-4 py-2 rounded mr-2"
                onClick={() => setIsModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="bg-green-500 text-white px-4 py-2 rounded"
                disabled={loading} 
                onClick={handleBulkSubmit}
              >
                {loading ? "Uploading..." : "Submit"}
              </button>
            </div>

<div className='h-[50vh] p-5 overflow-auto'>

   {/* Preview Table */}
   {excelData.length > 0 && (
              <table className="w-full border-collapse border text-sm">
                <thead>
                  <tr className="bg-gray-200">
                    {Object.keys(excelData[0]).map((key) => (
                      <th key={key} className="border p-2">{key}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {excelData.map((row, index) => (
                    <tr key={index} className="border">
                      {Object.values(row).map((value, i) => (
                        <td key={i} className="border p-2">{value}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

</div>
              
          </div>
        </div>
      )}
    </div>
  );
}
